import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson18 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code1 = (
  'text',
  `
  let x = 'Hello World!'; //using single quotes
  let y = "Welcome"; //using double quotes
  `
  );
  const code2 = (
  'text',
  `
  let x = 45; //integer
  let y = 45.5 //float
  let w = 4.52e+5; // exponential notation, same as 4.52e6 or 452000
  let z = 4.52e-5; //exponential notation, same as 0.0000425
  `
  );
  const code3 = (
  'text',
  `
  let isLoading = false;
  let hasLoaded = true;
  `
  );
  const code4 = (
  'text',
  `
  console.log(a); //undefined
  let arr = [1,2,3];
  console.log(arr[6]); //undefined
  `
  );
  const code5 = (
  'text',
  `
  console.log(a); //undefined
  let arr = [1,2,3];
  console.log(arr[6]); //undefined
  `
  );
  const code6 = (
  'text',
  `
  let cars['bmw', 'toyota', 'porsche', 'lexus'];
  console.log(cars[]); //bmw, toyota, porsche, lexus
  `
  );
  const code7 = (
  'text',
  `
  let greet = function() {
    console.log("hello");
  }
  console.log(greet()); //Hello!
  `
  );
  const code8 = (
  'text',
  `
  let person =  {
    name: "Pete Attah",
    age: 40,
    hobby: "coding"
  }
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
   <h3><strong>Data Types</strong></h3>
   <p>Programming languages have in-built data types and structures which differ from one language to another.</p>
   <p>Data types are certain type of inputs that are constrained or restricted to the type of value they can take, the programming language used and the type of operation that can be performed on them.</p>
   <div className="alert alert-secondary" role="alert">
   <h4 className="alert-heading"><strong>Dynamic Typing</strong></h4>
   <p>JavaScript is a loosely typed programming language. JavaScript variables are not directly associated with any particular value type, and variables of any type can assigned or re-assigned to it.</p>
   <p>Let's begin to look at these different data types one after the other.</p>
   </div>
  <h4><strong>JavaScript Primitives</strong></h4>
  <p>A primitive value is one that has no properties of methods.</p>
  <p>A primitive data type is one that has a primitive value.</p>
  <p>JavaScript has the following primitive data types:</p>
   <ol class="list-group list-group-numbered mb-4">
    <li class="list-group-item">String</li>
    <li class="list-group-item">Number</li>
    <li class="list-group-item">Boolean</li>
    <li class="list-group-item">Undefined</li>
    <li class="list-group-item">Null</li>
  </ol>
  <h4><strong>Composite Data Types</strong></h4>
 <p>JavaScript supports the following composite data types:</p>
 <ol class="list-group list-group-numbered mb-4">
   <li class="list-group-item">Object</li>
   <li class="list-group-item">Array</li>
   <li class="list-group-item">Function</li>
 </ol>
   <h4>1. <strong>String Data Type</strong></h4>
   <p>String comprises series of character and is often used to represent textual data.</p>
   <p>A String can be created by using the single or double quotation marks surrouned by one or more characters.</p>
   <CopyBlock
   language={language}
   text={code1}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
   <h4 className="mt-3">2. <strong>Number Data Type</strong></h4>
   <p>The number data type can represent positive or negative numbers with or without any decimal point. Exponential notations can also be used.</p>
   <CopyBlock
   language={language}
   text={code2}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
   <h4 className="mt-3">3. <strong>Boolean Data Type</strong></h4>
   <p>Boolean values can either be <code>true</code> or <code>false</code></p>
   <CopyBlock
   language={language}
   text={code3}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
   <p>Boolean values can also show up during comparisons as we have demonstrated when we treated <strong>operators.</strong></p>
   <h4 className="mt-3">3. <strong>Undefined Data Type</strong></h4>
   <p>Undefined is a global variable that JavaScript creates at runtime. JavaScript assigns <var>undefined</var> to any variable that has been declared but not initialized or defined.</p>
   <CopyBlock
   language={language}
   text={code4}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
  <div className="alert alert-secondary  mt-3" role="alert">
  <h4 className="alert-heading">Undefined  Vs Not Defined</h4>
  <p>While <var><strong>undefined</strong></var> is a data type, <var><strong>not defined</strong></var> variables are those that are not delcared at any given point of time with the declaration keywords like <var>var, let, const</var></p>
  </div>
  <h4>4. <strong>Null Data Type</strong></h4>
  <p><strong>null</strong> is a primitive data type and is used for boolean operations. It represents an empty or non-existent value. It is used to declare that a variable is empty.</p>
   <CopyBlock
   language={language}
   text={code5}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
   <h4 className="mt-3">5. <strong>Array Data Type</strong></h4>
   <p>Arrays are used to store multiple values in a single variable. Each value (also called an element) in an array has a numeric position, known as its index, and it may contain data of any data type-numbers, strings, booleans, functions, objects, and even other arrays. An array index
   usually begins from 0. We shall take an in-depth look at arrays in our next lesson.</p>
   <CopyBlock
   language={language}
   text={code6}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
  <h4 className="mt-3">6. <strong>Function Data Type</strong></h4>
   <p>Functions are callable objects that can execute a block of code. They are also assignable to variables.</p>
   <CopyBlock
   language={language}
   text={code7}
   showLineNumbers={lineNumbers}
   theme={dracula}
   wrapLines={true}
   codeBlock
   />
   <p>We have looked at <strong>functions</strong> in our previous lesson.</p>
    <h4>7. <strong>Objects</strong></h4>
    <p>A JavaScript object is a collection of named values. The named values are called <strong>properties</strong>.</p>
    <p>The values are written in a <var>name:value</var> pair.</p>
    <CopyBlock
    language={language}
    text={code8}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
<p>We shall look at <strong>objects</strong> in a more detailed lesson.</p>
<h3>Summary</h3>
    <ul class="list-group">
      <li class="list-group-item">Data types differ from language to language.</li>
      <li class="list-group-item">JavaScript is a dynamic typed language.</li>
      <li class="list-group-item">A primitive data type is one that has a primitive value.</li>
      <li class="list-group-item">Data types are restricted to the type of value they can take.</li>
    </ul>




    </div>
</div>
</div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson18
